import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
  OpcionesListaChequeo
} from '@app/shared';

@Injectable()
export class CheckListOptionsFormsService {

  constructor() { }

  /**
   * Formulario de campos de opcion listas de chequeo
   *
   * @param {OpcionesListaChequeo} [data]
   * @returns {BaseControl<any>[]}
   * @memberof CheckListOptionsFormsService
   */
  getForm(data?: OpcionesListaChequeo): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'txtLabelOpcion',
        value: data ? data.label : null,
        label: 'Texto de la opción',
        placeholder: 'Ingrese el texto a identificar la opción',
        order: 1,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'txtValorOpcion',
        value: data ? data.label : null,
        label: 'Valor de la opción',
        placeholder: 'Ingrese el valor de la opción',
        order: 2,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'chkPorDefecto',
        type: 'checkbox',
        value: data ? data.por_defecto : false,
        label: 'Valor por defecto',
        placeholder: 'Ingrese el valor de la opción',
        order: 3,
      })
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/check-list/check-list-options/shared/check-list-options.form.service.ts